import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import Tooltip from '@/components/Tooltip';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7824 14.1068L10.7896 4.10358C10.053 2.62782 7.9472 2.6278 7.21059 4.10357L2.21763 14.1068C1.55392 15.4365 2.52095 17 4.0071 17H13.9929C15.479 17 16.4461 15.4366 15.7824 14.1068ZM12.579 3.21041C11.1059 0.258875 6.89432 0.258861 5.42112 3.21038L0.428157 13.2136C-0.89926 15.8731 1.03478 19 4.0071 19H13.9929C16.9652 19 18.8992 15.8731 17.5719 13.2137L12.579 3.21041Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 6C10 5.44772 9.55228 5 9 5C8.44772 5 8 5.44772 8 6V10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10V6Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14C10 13.4477 9.55228 13 9 13Z",
      fill: "#12131A"
    })]
  }));
};

WarningIcon.defaultProps = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var DisconnectIcon = function DisconnectIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.9275 3.0733C12.4954 1.6412 10.178 1.6412 8.74758 3.0733L7.10727 4.71361L7.97059 5.57694L9.6109 3.93662C10.5216 3.0259 12.0587 2.92941 13.0642 3.93662C14.0714 4.94383 13.9749 6.47919 13.0642 7.38991L11.4239 9.03023L12.2889 9.89525L13.9292 8.25493C15.3579 6.82283 15.3579 4.5054 13.9275 3.0733ZM7.39165 13.0641C6.48093 13.9749 4.94388 14.0714 3.93836 13.0641C2.93115 12.0569 3.02764 10.5216 3.93836 9.61086L5.57867 7.97054L4.71366 7.10553L3.07334 8.74584C1.64124 10.1779 1.64124 12.4954 3.07334 13.9258C4.50545 15.3562 6.82288 15.3579 8.25329 13.9258L9.8936 12.2855L9.03028 11.4221L7.39165 13.0641ZM4.23968 3.378C4.21422 3.3528 4.17985 3.33866 4.14403 3.33866C4.10822 3.33866 4.07384 3.3528 4.04839 3.378L3.37805 4.04835C3.35284 4.0738 3.33871 4.10817 3.33871 4.14399C3.33871 4.17981 3.35284 4.21418 3.37805 4.23963L12.7629 13.6245C12.8154 13.6769 12.9017 13.6769 12.9542 13.6245L13.6245 12.9541C13.677 12.9016 13.677 12.8153 13.6245 12.7628L4.23968 3.378Z",
      fill: "black"
    })
  }));
};

DisconnectIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const icons = {
  warning: /*#__PURE__*/_jsx(WarningIcon, {}),
  disconnect: /*#__PURE__*/_jsx(DisconnectIcon, {})
};

const TooltipIcon = _ref => {
  let {
    className,
    icon = 'warning',
    variant = 'default',
    content
  } = _ref;
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "bottom",
    content: content,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(styles.icon, styles[`icon--${variant}`], className),
      children: icons[icon]
    })
  });
};

export default TooltipIcon;